import gql from 'graphql-tag';

import * as logger from 'utilities/loggerx';

import { getGraphQLClient } from './graphql';

export const updateTextBlocksMutation = gql`
  mutation UpdateTextBlocks(
    $videoId: ID!
    $items: [TextOverlayBlockItemInput!]!
  ) {
    setTextOverlayItems(videoId: $videoId, items: $items) {
      ... on TextToSpeechSavePlayload {
        status
      }
    }
  }
`;

export const sendTextBlocksUpdate = (videoId, items) => {
  const gqlClient = getGraphQLClient();

  const itemsNormalized = items.map(item => {
    // eslint-disable-next-line
    const { selected, editing, ...itemData } = item;

    return itemData;
  });

  return gqlClient
    .mutate({
      mutation: updateTextBlocksMutation,
      variables: {
        videoId,
        items: itemsNormalized,
      },
    })
    .catch(error => {
      logger.error(
        error,
        {
          message: `Unable to update textOverlay items`,
        },
        { team: logger.CREATE_TEAM }
      );
    });
};

export const getTextBlocksMutation = gql`
  query getTextOverlayItems($videoId: ID!) {
    getTextOverlayItems(videoId: $videoId) {
      ... on GetTextOverlayItemsPlayload {
        items {
          startTs
          endTs
          text
          left
          top
          width
        }
      }
    }
  }
`;

export const getTextBlocksRequest = videoId => {
  const gqlClient = getGraphQLClient();

  return gqlClient
    .query({
      query: getTextBlocksMutation,
      variables: {
        videoId,
      },
    })
    .then(({ data }) => {
      const items = data?.getTextOverlayItems?.items || [];

      const normalizedItems = items.map(item => {
        // eslint-disable-next-line
        const { __typename, ...itemData } = item;

        return {
          ...itemData,
          selected: false,
          editing: false,
        };
      });

      return normalizedItems;
    })
    .catch(error => {
      logger.error(
        error,
        {
          message: `Unable to get textOverlay items`,
        },
        { team: logger.CREATE_TEAM }
      );
    });
};
